var _rect, _rect2, _rect3, _rect4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "#F8F8FC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    stroke: "#EBEBEB",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3172_19080",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 20,
    height: 20
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3172_19080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 21.333L13.8333 17.1663L14.9999 15.958L17.1666 18.1247V11.333H18.8333V18.1247L20.9999 15.958L22.1666 17.1663L17.9999 21.333ZM12.9999 24.6663C12.5416 24.6663 12.1492 24.5031 11.8228 24.1768C11.4964 23.8504 11.3333 23.458 11.3333 22.9997V20.4997H12.9999V22.9997H22.9999V20.4997H24.6666V22.9997C24.6666 23.458 24.5034 23.8504 24.177 24.1768C23.8506 24.5031 23.4583 24.6663 22.9999 24.6663H12.9999Z",
    fill: "#22222F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.960339905a674c4ad6f93749ce5a9cdb.svg";
export { ForwardRef as ReactComponent };